import Column from 'components/Column';
import { Footer } from 'components/Footer';
import { Header } from 'components/Header';
import { H2, H4 } from 'components/Typography';
import { ENV_CONFIG } from 'config/environment';
import { HeaderVideo, TextContainer } from './styled';

export const LandingScreen = () => {
  return (
    <>
      <Header />
      <Column $alignItems="center" $justifyItems="center" $textAlign="center">
        <HeaderVideo autoPlay loop muted playsInline id="landing-video">
          <source src={`${ENV_CONFIG().CLOUDINARY.LANDING_VIDEO}/inicio.mp4`} type="video/mp4" />
        </HeaderVideo>
      </Column>
      {/* <ImageCarousel /> */}
      <TextContainer>
        <H2>ARQUEOLOGÍA DE LA LUZ</H2>
        <H4>
          Desarrollo una práctica que investiga la relación entre la luz, la memoria y la materia.
        </H4>
        <H4>
          Trabajo en capas, entendiendo cada estrato como una piel que protege, que revela una
          memoria y un archivo en construcción.
        </H4>
        <H4>
          A través de estas capas busco crear un puente hacia un origen que me habita: mi territorio
          simbólico al que mi obra siempre regresa.
        </H4>
        <H4>
          La luz en mis pinturas no aparece suavemente, irrumpe con fuerza, atravesando el caos y la
          rutina. Los contrastes radicales se convierten así en un gesto de transformación.
        </H4>
        <H4>
          Cada obra se vuelve una cartografía de retorno y liberación: un espacio donde el pasado,
          el cuerpo y la memoria se encuentran para dar lugar a un nuevo comienzo.
        </H4>
      </TextContainer>
      <Footer />
    </>
  );
};
